import { required } from 'vuelidate/lib/validators'
import { slugAsyncValidator, slugValidator, validationErrorMessages } from '@/utils/validations/validations'
import infoCategoriesSlugsQuery from '@/services/gql/types/InfoCategories/queries/infoCategoriesSlugs.gql'

export default ({ infoCategoryId, ctx, isNew }) => {
  const isUnique = async (value) => {
    return await slugAsyncValidator(value, infoCategoryId, infoCategoriesSlugsQuery, ctx, 'infoCategories')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    name: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: { validator: slugValidator, message: validationErrorMessages.slugGeneralMsg },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })()
  }
}
